import { FC, useEffect } from 'react'

import { EditChangeLogEntryForm } from '../../../containers/@forms/EditChangeLogEntryForm/EditChangeLogEntryForm'
import { ChangeLogEntry, EditChangeLogEntryFormData } from '../../../entities/ChangeLog/ChangeLog'
import trans from '../../../helpers/trans'
import { editChangeLogEntry } from '../../../redux/changeLogEntry/changeLogEntryActions'
import { setIsSuccessful } from '../../../redux/changeLogEntry/changeLogEntryReducer'
import { useTypedDispatch, useTypedSelector } from '../../../redux/store'
import { setToast } from '../../../redux/toasts/toastsReducer'
import { ToastType } from '../../../types'

interface ConnectedEditChangeLogEntryFormProps {
    changeLogEntry: ChangeLogEntry
    onClose: () => void
}

export const ConnectedEditChangeLogEntryForm: FC<ConnectedEditChangeLogEntryFormProps> = ({
    changeLogEntry,
    onClose,
}) => {
    const dispatch = useTypedDispatch()
    const { isLoading, isSuccessful } = useTypedSelector(state => state.changeLogEntryReducer)

    const handleEditChangeLogEntry = (editChangeLogEntryFormData: EditChangeLogEntryFormData): void => {
        dispatch(editChangeLogEntry(editChangeLogEntryFormData))
    }

    useEffect(() => {
        if (isSuccessful) {
            dispatch(setIsSuccessful(false))

            dispatch(setToast({
                text: trans('containers.forms.editChangeLogEntryForm.editChangeLogEntrySuccess'),
                type: ToastType.pass,
            }))

            onClose()
        }
    }, [isSuccessful])

    return (
        <EditChangeLogEntryForm
            isLoading={isLoading}
            changeLogEntry={changeLogEntry}
            onSubmit={handleEditChangeLogEntry}
            onCancel={onClose}
        />
    )
}
